import { updateField } from 'vuex-map-fields';
import { find } from 'lodash';

export default {
  START_LOADING_INTEGRATIONS(state) {
    state.integrationsLoaded = false;
  },
  SET_INTEGRATIONS(state, payload) {
    state.integrations = payload;
    state.integrationsLoaded = true;
    state.frontIntegrated = find(state.integrations, integration => integration.app === 'front');
  },
  INTEGRATION_DELETED(state, payload) {
    state.integrationDeleted = payload;
  },
  START_LOADING_FRONT_TOKEN(state) {
    state.frontTokenLoaded = false;
  },
  START_LOADING_FRONT_TEAMS(state) {
    state.frontTeamsLoaded = false;
  },
  SET_FRONT_TOKEN(state, payload) {
    state.frontToken = payload;
    state.frontTokenLoaded = true;
  },
  SET_FRONT_TEAMS_LIST(state, payload) {
    state.frontTeams = payload;
    state.frontTeamsLoaded = true;
  },
  SET_FRONT_INTEGRATED(state, payload) {
    state.frontIntegrated = payload;
  },
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  updateField,
};
